<template>
  <div>
    <v-alert v-if="error" color="red" type="error" tile>
      {{ error }}
    </v-alert>
    <v-alert v-else color="green" type="success" tile>
      Success !
    </v-alert>
    <v-card tile class="mx-auto yellow lighten-5 pa-2">
      <v-card-title class="ma-0 pa-0">
        <div class="d-flex align-center">
          <v-icon>mdi-information</v-icon>
          <span>Information</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="expandInfos = !expandInfos"
          ><v-icon>{{
            expandInfos ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-expand-transition>
          <div v-show="expandInfos">
            <v-text-field
              :value="correlationId"
              readonly
              label="Correlation ID"
            ></v-text-field>
          </div>
        </v-expand-transition>
      </v-card-text>
    </v-card>
    <v-card tile class="mx-auto yellow lighten-5 pa-2">
      <v-card-title class="ma-0 pa-0">
        <div class="d-flex align-center">
          <v-icon>mdi-bookmark-plus</v-icon>
          <span>Additional fields</span>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon @click="expandAddProps = !expandAddProps"
          ><v-icon>{{
            expandAddProps ? "mdi-chevron-up" : "mdi-chevron-down"
          }}</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-expand-transition>
          <v-textarea
            v-show="expandAddProps"
            :value="JSON.stringify(additionalFields, null, 4)"
            readonly
          >
          </v-textarea>
        </v-expand-transition>
      </v-card-text>
    </v-card>
    <v-card tile class="mx-auto lighten-5 pa-2">
      <v-card-title class="ma-0 pa-0 d-flex align-center">
        <v-icon>mdi-receipt</v-icon>
        <span>Order</span>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-textarea v-model="newOrder" auto-grow></v-textarea>
      </v-card-text>
    </v-card>

    <v-container>
      <div class="title black--text d-flex align-center">
        <v-icon :color="retry ? 'green' : 'red'"
          >mdi-checkbox-blank-circle</v-icon
        >
        <span class="ml-2">Retry</span>
      </div>
      <div v-if="retry">
        <v-row>
          <v-col>
            <div>This event can be retried</div>
            <div>Target: {{ retryTarget }} ({{ retryType }})</div>
            <v-checkbox
              v-for="option in retryOptions"
              :key="option"
              v-model="selectedOptions"
              :label="option"
              :value="option"
              hide-details
            ></v-checkbox>
          </v-col>
          <v-col>
            <v-alert v-if="payloadHasChanged" type="info" color="warning">
              You changed order's payload.
            </v-alert>
            <v-alert v-else type="info" color="info">
              Order payload hasn't changed.
            </v-alert>
            <v-alert v-if="!isValidJSON" type="error" color="error">
              Not a valid json, cannot send
            </v-alert>
            <div class="d-flex justify-space-between">
              <v-btn
                color="green"
                dark
                @click="retryOrder"
                :disabled="!isValidJSON"
              >
                <v-icon left>mdi-reload</v-icon>
                <span>Retry</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
      <div v-else>This event cannot be retried</div>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    order: { type: Object },
    retry: { type: Boolean },
    retryType: { type: String },
    retryTarget: { type: String },
    retryOptions: { type: Array },
    correlationId: { type: String },
    additionalFields: { type: Object },
    error: { type: String },
  },
  data() {
    return {
      newOrder: JSON.stringify(this.order, null, 4),
      expandAddProps: false,
      expandInfos: false,
      selectedOptions: [],
    };
  },
  computed: {
    payloadHasChanged() {
      return this.newOrder !== JSON.stringify(this.order, null, 4);
    },
    isValidJSON() {
      try {
        JSON.parse(this.newOrder);
        return true;
      } catch {
        return false;
      }
    },
    objectOrder() {
      return JSON.parse(this.newOrder);
    },
  },
  methods: {
    retryOrder() {
      this.$emit(
        "retry",
        this.objectOrder,
        this.selectedOptions,
        this.retryTarget,
        this.retryType
      );
    },
  },
};
</script>

<style></style>
